var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#008753"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_4581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9H22V19.6667H6V9ZM14 11.6667C14.7072 11.6667 15.3855 11.9476 15.8856 12.4477C16.3857 12.9478 16.6667 13.6261 16.6667 14.3333C16.6667 15.0406 16.3857 15.7189 15.8856 16.219C15.3855 16.719 14.7072 17 14 17C13.2928 17 12.6145 16.719 12.1144 16.219C11.6143 15.7189 11.3333 15.0406 11.3333 14.3333C11.3333 13.6261 11.6143 12.9478 12.1144 12.4477C12.6145 11.9476 13.2928 11.6667 14 11.6667ZM9.55556 10.7778C9.55556 11.2493 9.36825 11.7015 9.03486 12.0349C8.70146 12.3683 8.24927 12.5556 7.77778 12.5556V16.1111C8.24927 16.1111 8.70146 16.2984 9.03486 16.6318C9.36825 16.9652 9.55556 17.4174 9.55556 17.8889H18.4444C18.4444 17.4174 18.6317 16.9652 18.9651 16.6318C19.2985 16.2984 19.7507 16.1111 20.2222 16.1111V12.5556C19.7507 12.5556 19.2985 12.3683 18.9651 12.0349C18.6317 11.7015 18.4444 11.2493 18.4444 10.7778H9.55556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_4581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPayment);
export default __webpack_public_path__ + "static/media/request_payment.1faee557f261ca8723191a0dc1f81373.svg";
export { ForwardRef as ReactComponent };